// extracted by mini-css-extract-plugin
export default {"section":"PrivacySettingsModal_section__DhGf+"};